:host {
  display: block;
}

// sizes
.min {
  height: 60px;
  width: 60px;
}
.std {
  height: 84px;
  width: 84px;
}
.max {
  height: 108px;
  width: 108px;
}
